<template>
    <b-modal
        id="display-image" 
        ref="displayImage"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        @hidden="closeModal()"
    >
        <b-img
            :src="url"
            fluid-grow
            alt="Responsive image">
        </b-img>
    </b-modal>
</template>

<script>
export default {
    props:{
        url: {
            type: String
        }
    },
    methods: {
        closeModal(){
            this.$bvModal.hide("display-image");
        }
    }
}
</script>
